import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/PageHeader";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";
import { useProducts } from "@/hooks/useData";
import { CATEGORIES } from "@/lib/site";

export default function Store() {
  const [searchParams, setSearchParams] = useSearchParams();
  const collection = searchParams.get("collection") || "";
  const [category, setCategory] = useState("All");

  const params = collection ? `?collection=${encodeURIComponent(collection)}` : "";
  const { data: products = [], isLoading } = useProducts(params);

  const filtered = category === "All" ? products : products.filter((p) => p.category === category);

  useEffect(() => setCategory("All"), [collection]);

  return (
    <div data-testid="store-page">
      <PageHeader
        eyebrow={collection ? `Collection · ${collection}` : "The Store"}
        title={collection || "Curated"}
        accent={collection ? "" : "catalogue."}
        description="Every piece is available to source, customize and ship worldwide. Request a quote on anything that speaks to you."
      >
        {collection && (
          <button onClick={() => setSearchParams({})} className="mt-6 label-eyebrow text-[11px] text-[#9E8773] border-b border-[#9E8773] pb-0.5" data-testid="clear-collection">
            ← View entire store
          </button>
        )}
      </PageHeader>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <div className="flex flex-wrap gap-3 mb-12">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setCategory(c)}
              data-testid={`category-${c.toLowerCase().replace(/ /g, "-")}`}
              className={`label-eyebrow text-[10px] px-5 py-2.5 border transition-colors ${
                category === c ? "bg-[#2C2A29] text-[#FFFFFF] border-[#2C2A29]" : "bg-transparent text-[#5E5A54] border-[#ECEAE4] hover:border-[#9E8773]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>

        {isLoading ? (
          <p className="text-[#5E5A54] font-light">Loading…</p>
        ) : filtered.length === 0 ? (
          <p className="text-[#5E5A54] font-light py-20 text-center" data-testid="store-empty">No pieces in this category yet.</p>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-5 gap-y-10">
            {filtered.map((p, i) => (
              <Reveal key={p.id} delay={(i % 4) * 0.05}>
                <ProductCard product={p} />
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
